import { filesize } from 'filesize';

export const fileSize = (bytes: number) => {
  return filesize(bytes, { output: 'string' });
};
